import { isString } from 'util'

const MapContextMenu = GeoGlobe.Class4OL({
    menuDiv: null,
    className: null,
    contentHTML: null,
    lngLat: null,
    point: null,
    initialize: function(a) {
        GeoGlobe.Util.extend(this, a)
    },
    getDefaultPosition: function() {
        return 'top-left'
    },
    onAdd: function(a) {
        this._map = a
        this._onContextMenu = GeoGlobe.Function.bind(
            this._showContextMenu,
            this
        )
        this._map.on('contextmenu', this._onContextMenu)
        this._onMouseDown = GeoGlobe.Function.bind(this.hide, this)
        this._map.on('mousedown', this._onMouseDown)
        return (this._container = this._createContainer())
    },
    _createContainer: function() {
        var a = window.document.createElement('div')
        a.className = 'mapboxgl-ctrl mapboxgl-ctrl-map-context-menu'
        this.className && a.classList.add(this.className)

        a.style.position = 'absolute'
        a.style.zIndex = 1
        a.innerHTML = this.contentHTML ? this.contentHTML : ''

        this.menuDiv = a
        this.menuDiv.addEventListener('contextmenu', function(t) {
            t.cancelBubble = true
            return (
                (t = t || window.event),
                t.preventDefault ? t.preventDefault() : (t.returnValue = !1),
                !1
            )
        })

        this.hide()
        return a
    },
    _showContextMenu: function(a) {
        const flag =
            !this._map.isMoving() &&
            !this._map.isZooming() &&
            !this._map.isRotating()

        if (flag) {
            this.lngLat = a.lngLat
            this.point = a.point
            this.menuDiv.style.left = a.point.x + 'px'
            this.menuDiv.style.top = a.point.y + 'px'
            this.show()
        }
    },
    onRemove: function() {
        this._container.parentNode.removeChild(this._container)
        this._map.off('contextmenu', this._onContextMenu)
        this._map.off('mousedown', this._onMouseDown)
        this.contentHTML = this._container = this.menuDiv = null
        this._map = void 0
    },
    show: function() {
        if (this.menuDiv && this.menuDiv.style.display == 'none')
            this.menuDiv.style.display = ''
    },
    hide: function() {
        if (this.menuDiv && this.menuDiv.style.display != 'none')
            this.menuDiv.style.display = 'none'
    },
    setContentHTML: function(a) {
        if (a != null) this.contentHTML = a
        if (
            this.menuDiv != null &&
            this.contentHTML != null &&
            this.contentHTML != this.menuDiv.innerHTML
        )
            this.menuDiv.innerHTML = this.contentHTML
    },
    addItem: function(a) {
        var b = document.createElement('div')
        b.classList.add('mapboxgl-ctrl-map-context-menu-item')
        b.style.width = isString(a.width) ? a.width : a.width + 'px'
        b.innerHTML = '<span>' + a.text + '</span>'

        b.onclick = GeoGlobe.Function.bind(function() {
            a.callback({
                target: a,
                control: this,
                map: this._map,
                lngLat: this.lngLat,
                point: this.point
            })
            this.hide()
        }, this)
        this.menuDiv.appendChild(b)
        this.setContentHTML(this.menuDiv.innerHTML)
    },
    addSeparator: function() {
        var a = document.createElement('div')
        a.className = 'divider'
        this.menuDiv.appendChild(a)
        this.setContentHTML(this.menuDiv.innerHTML)
    },
    mousePos: function(a, b) {
        var c = a.getBoundingClientRect()
        return new GeoGlobe.Point(
            b.clientX - c.left - a.clientLeft,
            b.clientY - c.top - a.clientTop
        )
    },
    CLASS_NAME: 'GeoGlobe.View2D.Control.MapContextMenu'
})

export default MapContextMenu
